import { useMutation } from '@tanstack/react-query';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';
import { useTargetUidPayload } from './useTargetUidPayload';

export interface ProviderTestResult {
  ok: true;
  provider: 'twilio' | 'telnyx';
  /** Twilio: account friendly name. Telnyx: omitted. */
  friendlyName?: string;
  accountStatus?: string;
  accountType?: string;
  /** Telnyx-only: whether a connection ID is wired up. */
  connectionConfigured?: boolean;
}

/**
 * Validates the saved provider credentials with a single read-only API
 * hop. In admin mode the test runs against the TARGET user's saved
 * credentials, not the admin's own.
 */
export function useTestProviderCredentials() {
  const adminPayload = useTargetUidPayload();
  return useMutation({
    mutationFn: async (provider: 'twilio' | 'telnyx') => {
      const fn = httpsCallable<
        { provider: 'twilio' | 'telnyx'; uid?: string },
        ProviderTestResult
      >(functions, 'testProviderCredentials');
      const r = await fn({ provider, ...adminPayload });
      return r.data;
    },
  });
}
